// extracted by mini-css-extract-plugin
module.exports = {"container":"az_tQb","imageContainer":"az_uQb","image":"az_vQb","heading":"az_wQb","description":"az_xQb"};